import styled from 'styled-components';

const Container = styled.div`
  flex: none;
  width: 18rem;
  scroll-snap-align: start;
  cursor: pointer;
`;

const Thumb = styled.div`
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: var(--r-md);
  overflow: hidden;
  border: 1px solid var(--border);
  background-color: var(--surface-2);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform var(--dur-base) var(--ease-out);
  }

  ${Container}:hover & img {
    transform: scale(1.05);
  }
`;

const RankNumber = styled.span`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background-color: var(--ink);
  color: var(--bg);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.4rem;
  padding: 0.3rem 1rem;
  border-radius: var(--r-pill);
`;

const Name = styled.p`
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--ink);
  margin-top: 1rem;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Stat = styled.p`
  font-size: 1.2rem;
  color: var(--ink-faint);
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export { Container, Name, RankNumber, Stat, Thumb };
